import { gql } from 'graphql-request';

export const getCurrencyRatesQuery = gql`
  query GetCurrencyRates($date: String) {
    currencyRates(date: $date) {
      CHF_USD
      EUR_USD
      GBP_USD
      ILS_USD
    }
  }
`;
